module.exports = __webpack_public_path__ + "img/jap.5ca92884.png";